module.exports = __webpack_public_path__ + "static/media/meeting-view-icon.4a01fead.svg";